<template>
    <v-container fluid>
      <v-tabs dark v-model="tab" 
        show-arrows
        background-color="black"
        class="mt-1"
        >
          <v-tabs-slider color="red"></v-tabs-slider>
          <v-tab key="1">Inmortals</v-tab>
          <v-tab key="2">Still Standing</v-tab>
          <v-tab key="3">BaseLevel</v-tab>
          <v-tab key="4">Zeny</v-tab>
          <v-tab key="5">Deaths</v-tab>
          <v-tab key="6">Guilds</v-tab>
          <v-tab key="7">Achievements</v-tab>
      </v-tabs>
          <v-tabs-items v-model="tab" class="pt-4 black" dark>
              <v-tab-item key=1></v-tab-item>
              <v-tab-item key=2></v-tab-item>
          </v-tabs-items>


        <v-card :elevation="2" >
            <v-data-table
                :headers="headers"
                item-key="char_id"
                :search="search"
                :loading="loading"
                class="elevation-1"
                multi-sort
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                :items="items"
                :page="currentPage"
                :items-per-page="perPage"
                :items-per-page-options="itemsPerPageOptions"
                :options.sync="options"
                :server-items-length="totalRegistros" 
                :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-chevron-double-left',
                lastIcon: 'mdi-chevron-double-right',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                itemsPerPageOptions: [ 25, 50, 100]
                }"
            >
            <template v-slot:top>
                <v-toolbar flat>
                <v-card-title>Players</v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search Player"
                single-line
                hide-details
                ></v-text-field>
                </v-toolbar>
            </template>
            <template v-slot:item.name="{ item }">
                <span class="caption">{{item.name}}</span>
            </template>
            <template v-slot:item.class="{ item }">
                {{getjobName(item.class)}}
            </template>
            <template v-slot:item.zeny="{ item }">
                {{AddComas(item.zeny)}}z
            </template>
            </v-data-table>
        </v-card>
    </v-container>
  </template>
  
  <script>
import Vue from "vue";
import axios from 'axios'; 
  export default {
    data() {
      return {
        tab: 0,
        baseURL: 'char/ranking',
        search: '',
        loading: false,
        currentPage: 1,
        filter: '',
        sortBy: 'base_level',
        sortDesc: true,
        totalRegistros: 0,
        perPage:25,
        items: [],
        itemsPerPageOptions: [ 25, 50, 100],
        options: {
            itemsPerPage:25,
            page:1
        },
        headers: [
          { text: 'Char Name', value: 'name' },
          { text: 'Class', value: 'class' },
          { text: 'Base Level', value: 'base_level' },
          { text: 'Job Level', value: 'job_level' },
          { text: 'Zeny', value: 'zeny' },
          { text: 'Deaths', value: 'deaths' },
        ],
        rankingData: []
      };
    },
    mounted() {	
      this.getRegistros(0);
    },
    methods: {
      formatCurrency(value) {
        return new Intl.NumberFormat().format(value);
      },
      getRegistros(mode){
        this.items = [];
        this.totalRegistros = 0;
        if(this.sortBy) this.filter += 'sortBy='+this.sortBy;
        if(this.sortDesc) this.filter += '&sortDesc='+this.sortDesc;
        if(this.search_name) this.filter += '&name='+this.search_name;
        if(mode) this.filter += '&mode='+mode;
        this.perPage = this.options.itemsPerPage;
        this.filter += (!this.options.itemsPerPage?'':'&per_page='+this.options.itemsPerPage) + (!this.options.page?'':'&page='+this.options.page);
        this.loading = true;
        axios
        .get(this.baseURL+'?'+this.filter)
        .then(response => {
          this.items = response.data.data;
          this.registros = response.data;
          this.totalRegistros = response.data.total;
        })
        .catch(this.MSGBOX)
        .finally(() => {
          this.filter = '';
          this.loading = false; // Esto se ejecuta siempre
        });
      },
    },
    watch: {
      options : function (){
        this.getRegistros(0);
      },
      tab: function (){
        switch (this.tab) {
          case 0: this.mode = 1; break;
          case 1: this.mode = 2; break;
          case 2: this.mode = 3; break;
          case 3: this.mode = 4; break;
          case 4: this.mode = 5; break;
          case 5: this.mode = 6; break;
          case 6: this.mode = 7; break;
        }
        this.getRegistros(this.mode);
      },
    }
  };
  </script>
  
  <style scoped>
  /* Agrega estilos personalizados aquí si es necesario */
  </style>
  